import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallOfferAlertsComponent } from './components/call-offer-alerts/call-offer-alerts.component';
import { OtherAlertsComponent } from './components/other-alerts/other-alerts.component';
import { ListVuesCallOfferComponent } from './components/list-vues-call-offer/list-vues-call-offer.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'appel-offre',
    pathMatch: 'full',
  },
  {
    path:'appel-offre',
    component:CallOfferAlertsComponent,
  },
  {
    path:'liste',
    component:OtherAlertsComponent,
  },
  {
    path:'liste-vue-appel-offre',
    component:ListVuesCallOfferComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlertClientRoutingModule { }
